import { render, staticRenderFns } from "./history-component.vue?vue&type=template&id=c3134cd8&scoped=true"
import script from "./history-component.vue?vue&type=script&lang=js"
export * from "./history-component.vue?vue&type=script&lang=js"
import style0 from "./history-component.vue?vue&type=style&index=0&id=c3134cd8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3134cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3134cd8')) {
      api.createRecord('c3134cd8', component.options)
    } else {
      api.reload('c3134cd8', component.options)
    }
    module.hot.accept("./history-component.vue?vue&type=template&id=c3134cd8&scoped=true", function () {
      api.rerender('c3134cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/batch/history-component.vue"
export default component.exports